var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    strokeWidth: 0,
    d: "M22.68,22.68H0V0h22.68v22.68ZM.96,21.72h20.76V.96H.96v20.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    strokeWidth: 0,
    d: "M19.96,19.96H2.71V2.72h17.25v17.25ZM3.67,19.01h15.33V3.67H3.67v15.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/GLOBAL.7c2ce8c624dc55f93a234132c270533b.svg";
export { ForwardRef as ReactComponent };